import { Map, List, fromJS } from 'immutable';
import * as actionTypes from '../../../constants/actionTypes';
import * as filtersConstants from '../../../constants/filters';
import { ActionTypes as FiltersActionTypes } from "./SkuFiltersActions"
import { now } from 'moment';

const initialState = {
    showAssignFeature: false
};


const setShowAssignFeature = (state) => {
    return { ...state, showAssignFeature: !state.showAssignFeature };
};

export default (state = initialState, action) => {
    switch (action.type) { 
        case actionTypes.SKU_FILTER_RELATIONSHIP_OPEN_ASSIGN_FEATURE_POPUP:
            return setShowAssignFeature(state); 
        default:
            return state;
    }
};